module.exports = __webpack_public_path__ + "img/p1.70fd7cdf.png";